module.exports = __webpack_public_path__ + "static/media/fr.e0eaebde.svg";